<template>
	<div class="wrap">
		<div class="container">
			<div class="wuliu">
				<h3 class="personal_titile">物流信息</h3>
				<van-steps direction="vertical" :active="0">
					<van-step v-for="(value,index) in logistics" :key="index">
						<h3>[{{value.weiZhi}}]&nbsp;{{value.miaoShu}}</h3>
						<p>{{value.date}}</p>
					</van-step>
				</van-steps>
			</div>
		</div>
		<v-foot></v-foot>
	</div>
</template>

<script>
	// @ is an alias to /src
	export default {
		components: {},
        created() {
            this.id = this.$route.query.id;
            this.getData();
        },
        data() {
			return {
                id: 0,
                logistics: [],
			}
		},
		methods: {
            getData(){
                var url = 'api/order/logistics';
                var _self = this;

                this.POST(url,{id:this.id},function (ret){
                    _self.logistics = ret.data.data;
                })
            }
		},
	}
</script>